var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMultiFlight = function SvgMultiFlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98245 3.5443L0.666504 11.834H8.25345C9.17957 11.834 9.98456 11.1982 10.1991 10.2972L12.1275 2.19774C12.2324 1.75705 11.8983 1.33398 11.4453 1.33398C9.69425 1.33398 8.04364 2.15149 6.98245 3.5443Z",
    fill: "#BEF7A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1082 6.21124L3.6665 14.666H11.2535C12.1796 14.666 12.9846 14.0302 13.1991 13.1293L15.0794 5.23168C15.2089 4.68797 14.7966 4.16602 14.2377 4.16602C12.6175 4.16602 11.0902 4.92246 10.1082 6.21124Z",
    fill: "#44B50C"
  })));
};
export default SvgMultiFlight;